import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import tableModel from './tableModel.vue';
import pictureItem from './picture.vue';
import areaSelect from '@/components/cascader.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import country from '@/components/country.vue';
import previewListModal from '@/views/claim/demageManage/previewListModal.vue';
export default {
  components: {
    topTitle,
    tableModel,
    areaSelect,
    pictureItem,
    country,
    previewListModal
  },
  props: {
    infoList: {
      type: Array,
      default() {
        return [];
      }
    },
    sharedNodeInfo: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      tableShow: false,
      editableAreaInfo: [],
      tableKey: Date.now(),
      previewListVisible: false,
      modalPreviewList: []
    };
  },
  mounted() {
    this.editableAreaInfo = recursionCopy(this.infoList);
    this.editableAreaInfo.map(item => {
      if (item.controlType == 'table') {
        item.control.map(con => {
          con.slots = {
            title: con.title
          };
          delete con.title;
          return con;
        });
      }
      if (item.controlType == 'table' && item.operation == 'addEditDel') {
        item.control.push({
          slots: {
            title: this.$t('操作')
          },
          scopedSlots: {
            customRender: 'action'
          },
          key: '100',
          align: 'center'
        });
        item.value = [];
      } else if (item.controlType == 'table' && item.operation == 'lossDetermination') {
        item.value = this.getTableFun(item.operation);
        item.control.splice(item.control.length - 1, 1, {
          fixed: 'right',
          slots: {
            title: this.$t('定损意见')
          },
          dataIndex: 'loss',
          key: '7',
          align: 'center',
          scopedSlots: {
            customRender: 'loss'
          },
          width: 200
        });
      } else if (item.controlType == 'table' && item.operation == 'nuclearDamage') {
        item.value = this.getTableFun(item.operation);
        item.control.splice(item.control.length - 1, 1, {
          fixed: 'right',
          slots: {
            title: this.$t('核损意见')
          },
          dataIndex: 'damage',
          key: '8',
          align: 'center',
          scopedSlots: {
            customRender: 'damage'
          },
          width: 200
        });
      } else if (item.controlType != 'table') {
        item.control.map(item2 => {
          if (item2.partsType == 'picture' || item2.partsType == 'enclosure') {
            item2.value = [];
          }
        });
      }
    });
  },
  methods: {
    addItemFun(index) {
      let control = recursionCopy(this.editableAreaInfo[index].control);
      control.map(item => item.value = '');
      console.log(control);
      let controlItem = recursionCopy(this.editableAreaInfo[index]);
      controlItem.control = control;
      controlItem.other = 0;
      controlItem.delete = 1;
      this.editableAreaInfo.splice(index + 1, 0, controlItem);
    },
    deleteItemFun(index) {
      this.editableAreaInfo.splice(index, 1);
    },
    addTableFun(val, index, type) {
      this.tableShow = true;
      const id = val ? val.id : this.editableAreaInfo[index].value.length + 1;
      this.$nextTick(() => {
        this.$refs.tableFrom.init(val, id, index, type);
      });
    },
    tableOk(val2, index) {
      const num = this.editableAreaInfo[index].value.findIndex(val => {
        return val.id == val2.id;
      });
      if (num == -1) {
        this.editableAreaInfo[index].value.push(val2);
      } else {
        this.editableAreaInfo[index].value.splice(num, 1, val2);
      }
      console.log(this.editableAreaInfo[index].value);
    },
    delTableFun(index, num) {
      // let arr = [];
      // this.editableAreaInfo[index].value.map((item, index) => {
      //   if (index != num) {
      //     arr.push(item);
      //   }
      // });
      // Vue.set(this.editableAreaInfo[index],'value',arr);
      // this.editableAreaInfo[index].value=arr;
      this.editableAreaInfo[index].value.splice(num, 1);
      // console.log(this.editableAreaInfo[index]);
      // this.$refs['table'+index].refresh();
      this.tableKey = Date.now();
    },
    getTableFun(name) {
      let arr = [];
      let cont = name == 'lossDetermination' ? 'addEditDel' : 'lossDetermination';
      this.sharedNodeInfo.map((item, index) => {
        item.sharedData.map((item2, index2) => {
          if (item.method == 'COUNTERSIGN') {
            item2.editableArea.map((item3, index3) => {
              if (item3.controlType == 'table' && item3.operation == cont) {
                arr = item3.value;
              }
            });
          } else {
            if (item2.operation == cont) {
              arr = item2.value;
            }
          }
        });
      });
      return arr;
    },
    selectArea(value, valueName, index, index2) {
      this.editableAreaInfo[index].control[index2].value = valueName;
    },
    selectCountry(valueName, index, index2) {
      this.editableAreaInfo[index].control[index2].value = valueName;
    },
    clickPlus(index, index2) {
      this.$nextTick(() => {
        this.toChangeUploadAccept(this.editableAreaInfo[index].control[index2].fileFormat);
        this.fileDialog = true;
      });
    },
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      if (data.length) {
        data = data.map(i => '.' + i);
        return data.join(',');
      } else {
        return 'image/*';
      }
    },
    pictureOk(arr, index, index2) {
      this.editableAreaInfo[index].control[index2].value = arr;
    },
    onDateChange(val, index, index2) {
      this.editableAreaInfo[index].control[index2].value = val || '';
    },
    onModalPreview(arr) {
      this.modalPreviewList = arr.map((item, i) => {
        let name = item.substring(item.lastIndexOf('/') + 1, item.lastIndexOf('.'));
        let format = item.substring(item.lastIndexOf('.')).toLowerCase();
        let obj = {};
        obj.status = 'done';
        obj.uid = i + 1;
        obj.url = item;
        obj.format = format.slice(1);
        obj.name = name + format;
        return obj;
      });
      console.log(this.modalPreviewList);
      this.previewListVisible = true;
    }
  }
};